'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Common.DynamicClass', []).directive('rmDynamicClass', require('./directives/DynamicClassDirective'));